/**
 * The Norce category Id a category tile (`category-hero` blok) points at.
 *
 * `category_id` is the field backed by the Norce category datasource (the full
 * tree, same as the menu node). `id` is the older field with a hand-kept list
 * of categories. Each client space gets the new field on its own schedule, so
 * the new field wins when it is set and the old one keeps existing tiles
 * working until they are moved over (NF-387).
 */
export const categoryHeroId = (blok: {
	category_id?: string | number | null;
	id?: string | number | null;
}): string | number | null | undefined => blok.category_id || blok.id;
